// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { AtecoCodeFragment } from '../../../../settings/graphql/fragments/generated/ateco-code.fragment.generated';
import { VatRateFragment } from '../../../../settings/graphql/fragments/generated/vat-rate.fragment.generated';
export type DepartmentFragmentFragment = { __typename?: 'DepartmentDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, sellGoods: boolean, vatRateId: number, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null, vatRate: { __typename?: 'VatRateDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, ownerId: number, rate: number, referenceOnZeroVat: string | null, naturaTypeOnZeroVat: Types.NaturaTypeEnumDto | null, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null } };

export const DepartmentFragmentFragment = gql`
    fragment DepartmentFragment on DepartmentDTO {
  atecoCode {
    ...AtecoCode
  }
  atecoCodeId
  cashRegisterCode
  description
  id
  sellGoods
  vatRate {
    ...VatRate
  }
  vatRateId
}
    ${AtecoCodeFragment}
${VatRateFragment}`;
/* eslint-enable */